import User from './User.js';

class WishlistClass {

    articles = null;

    async getArticles() {

        if ( this.articles !== null ) {
            return this.articles;
        }

        return this._getArticleAjax()
        .then( ({data}) => this.updateWith(data) );
    }

    _getArticleAjax() {

        // Prefetched Article Array.
        if ( 'undefined' !== typeof window.ACL_USER_DATA ) {

            return User.getData()
            .then( response => {
                const userData = response?.data?.user;

                return {
                    'data': {
                        'items': userData.wishlist,
                        'count': userData.wishlistCount
                    }
                };
            });
        }

        // If not availabe ( e.g. on Basketpages ), use a more direct call as fallback.
        return fetch( '/index.php?cl=account_noticelist&fnc=getNoticeList&ajax=1', {
            method: 'GET',
            credentials: 'include',
            mode: 'no-cors',
            headers: {
                'Accept': 'application/json'
            }
        } )
        .then( response => response.json() )
        .then( response => {
            if ( ! response.success ) {
                throw response.error;
            }
            return response;
        } );
    }

    getArticle( articleId ) {
        const articles = this.articles || [];
        return articles.find( item => item.aid === articleId );
    }

    hasArticle( articleId ) {
        const articleCount = this.getArticle( articleId )?.amt || 0;
        return articleCount > 0;
    }

    addArticle( articleId, amount = 1 ) {

        const params = new URLSearchParams({
            'cl': 'account_noticelist',
            'fnc': 'addArticleToNoticeList',
            'ajax': 1
        })

        const formData = new FormData();
        formData.append( 'aid', articleId );
        formData.append( 'amt', amount );
        formData.append( 'stoken', window._stoken );

        // Load Data from minibasket_ajax and update settings.
        return fetch( '/index.php?' + params.toString(), {
            method: 'POST',
            credentials: 'include',
            mode: 'no-cors',
            headers: {
                'Accept': 'application/json'
            },
            body: formData
        } )
        .then( response => response.json() )
        .then( response => {
            if ( ! response.success ) {
                throw response.error;
            }
            return response;
        } )
        .then( ({data}) => this.updateWith(data) )
        .then((data) => {
            if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage("wishlist::update");
            }
            return data;
        });
    }

    removeArticle( articleId ) {
        return this.addArticle( articleId, 0 );
    }

    // Always Update Header.
    updateWith( data ) {

        // Get Data.
        const {items=[], count=0} = data;

        // Update Local Store of Wishlist Items.
        this.articles = items;

        // Update HTML.
        const wishlistElement = document.getElementById( 'acl_js--wishlist_items' );
        if ( wishlistElement ) {
            const wishlistCounter = wishlistElement.querySelector( '[data-count-element]' );
            if ( wishlistCounter ) {
                wishlistCounter.innerHTML = count;
                wishlistCounter.classList.toggle( 'en_hidden', count <= 0 );
            }
        }

        return data;
    }
}

// Create Class Instance.
const Wishlist = new WishlistClass();

// Export Wishlist Utility Class.
export default Wishlist;
